import { render, staticRenderFns } from "./ChannelCountCell.vue?vue&type=template&id=fce08acc&scoped=true"
import script from "./ChannelCountCell.vue?vue&type=script&lang=js"
export * from "./ChannelCountCell.vue?vue&type=script&lang=js"
import style0 from "./ChannelCountCell.vue?vue&type=style&index=0&id=fce08acc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce08acc",
  null
  
)

export default component.exports